import React from 'react';
import '../../styles/home.css';

function Home() {
  return (
    <div className="main-container">
      <h1>Welcome To The BOOKSTORE!</h1>
      <h3>Browse your hearts content!</h3>
    </div>
  );
}

export default Home;
